import React, { Suspense } from 'react'
import Spinner from 'components/Spinner'
import { FullPageContainer, MapSidebar, DummyMapWrapper, MapLoadingTitle } from 'map/style'
import { FormattedMessage } from 'react-intl'
import WebmapConfigProvider from 'providers/webmapConfig'

const MapPageLazyLoadWrapper = ({ children, sidebarWidth, footerHeight, headerHeight }) => {
  return (
    <FullPageContainer footerHeight={footerHeight} headerHeight={headerHeight}>
      <WebmapConfigProvider>
        <Suspense fallback={(
          <>
            <MapSidebar width={sidebarWidth} />
            <DummyMapWrapper>
              <MapLoadingTitle>
                <FormattedMessage id='loadingMap' />
              </MapLoadingTitle>
              <Spinner />
            </DummyMapWrapper>
          </>
        )}>
          {children}
        </Suspense>
      </WebmapConfigProvider>
    </FullPageContainer>
  )
}

export default MapPageLazyLoadWrapper
